export default __webpack_public_path__ + "static/media/dietary.128623da.png";